var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{staticClass:"custom-padding-bottom-10px"},[_c('div',{staticClass:"total"},[_vm._v(" "+_vm._s(_vm.total)+" ")]),_c('div',{ref:"sexTypeStatisticsChart",staticStyle:{"height":"200px"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }